import {DataStatus, showNotification} from 'platform/components';
import {Show} from 'platform/foundation';

import {isNotNil} from 'ramda-adjunct';

import {
  useGetHyundaiPromisePlatformQuery,
  useHyundaiPromiseAuthenticateMutation,
} from '@dms/api/sales';
import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';
import {useBranchId} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {
  PlatformAuthenticationFormHyundaiPromise,
  PlatformAuthenticationFormProps,
} from './components/PlatformAuthenticationFormHyundaiPromise';
import {PlatformPhotoSettings} from './components/PlatformPhotoSettings';

export function PlatformSettingsHyundaiPromise() {
  const branchId = useBranchId();
  const params = {branchId};
  const {data, isLoading, isError} = useGetHyundaiPromisePlatformQuery({params});
  const [saveAuthentication] = useHyundaiPromiseAuthenticateMutation();

  const onSubmitCredentials: PlatformAuthenticationFormProps['onSubmit'] = (values) =>
    saveAuthentication({
      body: values,
      params,
    })
      .unwrap()
      .then(() => showNotification.success())
      .catch(handleApiError);

  return (
    <Show whenFeatureEnabled={featureFlags.ADVERTISEMENT_GENERAL_SETTINGS}>
      <DataStatus isLoading={isLoading} isError={isError}>
        {isNotNil(data) && (
          <PlatformAuthenticationFormHyundaiPromise
            defaultValues={data.credentials}
            onSubmit={onSubmitCredentials}
          />
        )}
        <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.HYUNDAI_PROMISE} />
      </DataStatus>
    </Show>
  );
}
